var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HoraryForm',{key:_vm.schedule.id,ref:"elHorary",attrs:{"content":_vm.schedule,"employee_id":_vm.employee_id},on:{"saved":function($event){return _vm.handlerAfterSave($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }